import { Component, HostListener, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IrbAppEvents } from "@irb/app.events";
import { AppService } from "@irb/app.service";
import { AnalyticsService } from "@irb/irb-common/analytics/analytics.service";
import { ModelsService } from "../models-new/models.service";

@Component({ standalone: false,
  selector: "irb-finmason-disclosure-dialog",
  templateUrl: "./finmason-disclosure-dialog.component.html",
  styleUrls: ["./finmason-disclosure-dialog.component.scss", "../../irb-common/styles/dialog.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class FinmasonDisclosureDialogComponent implements OnInit {
  responseData: any = {};
  constructor(
    public dialogRef: MatDialogRef<FinmasonDisclosureDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public as: AppService, 
    public modelsService: ModelsService,
    private ats: AnalyticsService
  ) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }

  getFimasonToken() {
    this.ats.trackClickEvent("lc_finmason_continue"); 
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

    const f = () => {
      this.modelsService.getFinmasonAuthToken().subscribe((data: any) => {
          if (data.responseStatus && data.responseStatus === "EXCEPTION") {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: "error",
              summary: "Finmason Disclosure",
              detail: "An error occurred processing your request."
            });
          } else {
            const url = data.vendorUrl + "?token=" + data.token + "&loadPortfolio=" + this.data.loadPortfolio;
            this.responseData.targetOrigin = data.vendorUrl.split('/').slice(0, 3).join('/');
            window.open(url, "_blank"); //open url, if loading portfolios wait to receive message then send positions

            if(!this.data.loadPortfolio) {//if not loading portfolios, close dialog
              this.close();
              this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            }
          }
      });
    };
      
    if (this.data.loadPortfolio) {
      this.modelsService.getFinScorePortfolioRequest(this.data.selectedPortfolios[0].portfolioId).subscribe((data: any) => {
        if (data != null) {
          this.responseData.portfolioPositions = data;
        } else {
          this.responseData.portfolioPositions = { app: "5MFP", type: "PORTFOLIO", positions: [] };
        }
        
        f();
      });
    } else {
      f();
    }
  }

  @HostListener("window:message", ["$event"])
  receiveMessage(event: Event) {
    const message = event as MessageEvent;
    if (message.data && message.data.app === "5MFP" && message.data.state === "LISTEN_TO_PORTFOLIO") {
      this.sendMessage(message);
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    }
  }

  sendMessage(data: any) {
    const windowTarget = data.source;
    windowTarget.postMessage(this.responseData.portfolioPositions, this.responseData.targetOrigin);
    window.removeEventListener("message", this.receiveMessage);
  }
}
